/**
 * 客户门户 - 核心 API
 * 登录、退出、用户信息、修改密码
 *
 * @author system
 * @date 2026-09-09
 */
import request from '@/utils/request-customer'

/**
 * 客户门户登录
 *
 * @param {Object} data - { loginName: 手机号, password: 密码 }
 * @returns {Promise}
 */
export function customerPortalLogin(data) {
    return request({
        url: '/customer/login',
        method: 'post',
        data
    })
}

/**
 * 客户门户退出登录
 *
 * @returns {Promise}
 */
export function customerPortalLogout() {
    return request({
        url: '/customer/logout',
        method: 'post'
    })
}

/**
 * 获取客户门户用户信息
 *
 * @returns {Promise}
 */
export function getCustomerPortalInfo() {
    return request({
        url: '/customer/info',
        method: 'get'
    })
}

/**
 * 客户门户修改密码
 *
 * @param {Object} data - { oldPassword: 旧密码, newPassword: 新密码 }
 * @returns {Promise}
 */
export function customerPortalChangePassword(data) {
    return request({
        url: '/customer/changePassword',
        method: 'post',
        data
    })
}
